export default "<div class=\"facility-detail__description\">\n  <div [innerHTML]=\"facility?.Details?.Description | safe: 'html'\"></div>\n</div>\n"